import { RsValue } from '../../models/base/BaseModel';
import { IDashboardStats, IUserMonthlyRecordCount } from '../../models/dashboard/dashboardModel';
import api from '../axios';

export const dashboardService = {
  // Tüm dashboard istatistiklerini getir
  getDashboardStats: (): Promise<RsValue<IDashboardStats>> => api.get('api/Dashboard/stats'),

  // Hastane kayıt dağılımını getir
  getHospitalRecordDistribution: (): Promise<RsValue<IDashboardStats['hospitalRecordCounts']>> =>
    api.get('odata/Dashboard/hospital-distribution'),

  // Aylık kayıt istatistiklerini getir
  getMonthlyRecordStats: (
    year?: number
  ): Promise<RsValue<IDashboardStats['monthlyRecordCounts']>> =>
    api.get('odata/Dashboard/monthly-stats', { params: { year } }),

  // Toplam hastane ve kayıt sayılarını getir
  getTotalCounts: (): Promise<RsValue<Pick<IDashboardStats, 'totalHospitals' | 'totalRecords'>>> =>
    api.get('api/Dashboard/total-counts'),

  // Son 6 ay kullanıcı bazlı aylık kayıt sayıları (backend her zaman 6 ay döner)
  getUserMonthlyRecordStats: (): Promise<RsValue<IUserMonthlyRecordCount[]>> =>
    api.get('api/Dashboard/user-monthly-stats'),
};
